import { render, staticRenderFns } from "./MbgDateTimeInput.vue?vue&type=template&id=63ea1180&"
import script from "./MbgDateTimeInput.vue?vue&type=script&lang=js&"
export * from "./MbgDateTimeInput.vue?vue&type=script&lang=js&"
import style0 from "./MbgDateTimeInput.vue?vue&type=style&index=0&id=63ea1180&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports